import { action } from 'typesafe-actions';

import { INewKnmPlan } from 'APIPackage/PlanListModule/interfaces/INewKnmPlan';
import { PlanStatusEnum } from 'APIPackage/PlanListModule/enums/PlanStatusEnum';
import { ExportFormatsEnum } from 'APIPackage/ImportExportModule/enums/ExportFormatsEnum';
import { IKnm } from 'APIPackage/KnmModule/interfaces/IKnm';
import { IConsiderPlan } from 'APIPackage/PlanListModule/interfaces/IConsiderPlan';
import { IPlanStatusUpdate } from 'APIPackage/PlanListModule/interfaces/IPlanStatusUpdate';
import { ErknmPlanStatusesEnum } from 'APIPackage/PlanListModule/enums/ErknmPlanStatusesEnum';
import { IKnmReasonChangeType } from 'APIPackage/CatalogsModule/interfaces/IKnmReasonChangeType';
import { IValidatedUnsignedKnmError } from 'APIPackage/KnmModule/interfaces/IValidatedUnsignedKnmByPlan';

import { PlanListActionsEnum } from '../enums/PlanListActionsEnum';
import { IKnmPlan } from '../interfaces/IKnmPlan';
import { ISelectOption } from '../../../UIPackage/MainModule/components/SelectInput';

export const planListInitPage = () => action(PlanListActionsEnum.PLAN_LIST_INIT_PAGE);
export const planListCreatePlan = (
  plan: INewKnmPlan,
  getSuccessLink: (id: number) => JSX.Element,
  onClose: () => void,
) => action(PlanListActionsEnum.PLAN_LIST_CREATE_PLAN, { plan, getSuccessLink, onClose });
export const planListRemovePlans = (ids: Array<number>) => action(PlanListActionsEnum.PLAN_LIST_REMOVE_PLANS, { ids });
export const planListUpdatePlanStatus = (id: number, status: PlanStatusEnum, searchValue: string) =>
  action(PlanListActionsEnum.PLAN_LIST_UPDATE_PLAN_STATUS, { id, status, searchValue });
export const planListUpdateErknmPlanStatus = (
  id: number,
  data: IPlanStatusUpdate,
  knmAmount: number,
  searchValue?: string,
) => action(PlanListActionsEnum.PLAN_LIST_UPDATE_ERKNM_PLAN_STATUS, { id, data, knmAmount, searchValue });
export const planListUpdatePlanStatusToConsider = (id: number, data: IConsiderPlan, searchValue?: string) =>
  action(PlanListActionsEnum.PLAN_LIST_UPDATE_PLAN_STATUS_TO_CONSIDER, { id, data, searchValue });
export const planListGetData = (searchValue = '') => action(PlanListActionsEnum.PLAN_LIST_GET_DATA, { searchValue });
export const planListGetDataNextPage = () => action(PlanListActionsEnum.PLAN_LIST_GET_DATA_NEXT_PAGE);
export const planListSetData = (data: IKnmPlan[], page: number, pageCount: number, totalCount: number) =>
  action(PlanListActionsEnum.PLAN_LIST_SET_DATA, { data, page, pageCount, totalCount });
export const planListSetOrder = (order: string | null) => action(PlanListActionsEnum.PLAN_LIST_SET_ORDER, { order });
export const planListExportPlans = (format: ExportFormatsEnum) =>
  action(PlanListActionsEnum.PLAN_LIST_EXPORT_PLANS, { format });
export const planListExportPlanById = (format: ExportFormatsEnum, id: number, isApproved = false) =>
  action(PlanListActionsEnum.PLAN_LIST_EXPORT_PLAN_BY_ID, { format, id, isApproved });
export const planListExportDocsForKno = (planId: number) =>
  action(PlanListActionsEnum.PLAN_LIST_EXPORT_DOCS_FOR_KNO, { planId });
export const planListLinkKnmToPlan = (planId: number, knmId: IKnm['erpId'], reasonChangeType?: IKnmReasonChangeType) =>
  action(PlanListActionsEnum.PLAN_LIST_LINK_KNM_TO_PLAN, { planId, knmId, reasonChangeType });
export const planListGetStatuses = () => action(PlanListActionsEnum.PLAN_LIST_GET_STATUSES);
export const planListSetStatuses = (statuses: Array<PlanStatusEnum | ErknmPlanStatusesEnum>) =>
  action(PlanListActionsEnum.PLAN_LIST_SET_STATUSES, { statuses });
export const planListGetPlanById = (id: number | null) => action(PlanListActionsEnum.PLAN_LIST_GET_PLAN_BY_ID, { id });
export const planListSetPlan = (plan: IKnmPlan | null) => action(PlanListActionsEnum.PLAN_LIST_SET_PLAN, { plan });
export const planListSignPlanById = (
  planId: number,
  certificate: string,
  searchValue: string,
  errors: IValidatedUnsignedKnmError[],
) => action(PlanListActionsEnum.PLAN_LIST_SIGN_PLAN_BY_ID, { planId, certificate, searchValue, errors });
export const planListGetApprovedForCurrentYear = (
  frguProsecutorOrgId: number | string | null,
  knoId: number | string | null,
  ervkProsecutorOrgId: string | null,
  kindKontrolId: string,
) =>
  action(PlanListActionsEnum.PLAN_LIST_GET_APPROVED_FOR_CURRENT_YEAR, {
    frguProsecutorOrgId,
    knoId,
    ervkProsecutorOrgId,
    kindKontrolId,
  });
export const planListSetApprovedForCurrentYear = (plans: Array<number>) =>
  action(PlanListActionsEnum.PLAN_LIST_SET_APPROVED_FOR_CURRENT_YEAR, { plans });
export const planListGetPlanSelectOptions = (
  planIdQuery: string,
  isErp: boolean,
  callback: (options: ISelectOption[]) => void,
) => action(PlanListActionsEnum.PLAN_LIST_GET_PLAN_SELECT_OPTIONS, { planIdQuery, isErp, callback });
